import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { useMemo } from 'react';
import { SliderBase } from '@/components/ui/Slider/SliderBase';
import { getScreenValueOfNumber } from '@/utils/style/config';
export const CardSlider = (props) => {
    const { children, className, customSetting = {}, customSettingMd = {}, isLeft = true, paddingClassName = 'px-40', } = props;
    const setting = useMemo(() => (Object.assign({ adaptiveHeight: true, arrows: true, infinite: false, responsive: [
            {
                breakpoint: getScreenValueOfNumber('md'),
                settings: Object.assign({ infinite: false, slidesToShow: 1 }, (customSettingMd !== 'unslick' ? customSettingMd : {})),
            },
        ], slidesToShow: 3, swipeToSlide: true }, customSetting)), [customSetting, customSettingMd]);
    // スライド数が少ない場合の位置調整
    const customSlideStyle = css `
    .slick-list > div {
      margin-left: ${isLeft ? '0px' : 'auto'};
    }
  `;
    return (_jsx("div", Object.assign({ css: customSlideStyle }, { children: _jsx(SliderBase, Object.assign({ className: clsx(className, paddingClassName), customNextButtonProps: { customClassName: 'right-0' }, customPrevButtonProps: { customClassName: 'left-0' }, setting: setting }, { children: children })) })));
};
